import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toggleCreditOnCartItem } from '../modules/computed_cart';
import { MAX_QUANTITY } from '../shared/cart';
import { removeCartProduct, updateProductCart} from '../modules/cart_actions';

class ModalCartItem extends Component {

  constructor(props) {
    super(props);
    this.state = {
      arrayItem: this.props.arrayItem,
      showCredit: this.props.showCredit
    }
    this.creditAlter = this.creditAlter.bind(this);
    this.quantityAlter = this.quantityAlter.bind(this);
  }

  quantityAlter(product, event){
    this.props.dispatch( updateProductCart( product, parseInt(event.target.value)));
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      arrayItem: nextProps.arrayItem,
      showCredit: nextProps.showCredit
    });
  }

  creditAlter(product_id, event){
    this.props.dispatch( toggleCreditOnCartItem( product_id, this.state.arrayItem, parseInt(event.target.value)));
  }

  render() {
    let { computedCart, store_bundle_pricing, credit_eligible, credit_total} = this.props;
    let product = computedCart.items[this.state.arrayItem];
    let hasPromo = (computedCart.promo_items.length > 0 && computedCart.promo_items[this.state.arrayItem] !== null) ? true : false;
    let promo = product && hasPromo ? computedCart.promo : null;

    // handle null/undefined values in cart (position 0, reserved for FS)
    if (!product) {
      return <tr />
    }
    // must be Neglite store for credits, and book must be eligible, and customer's credits must be > 0
    // for credit toggle to be visible
    let countCreditEligible = product.subPrices ? product.subPrices.filter( x => x <= credit_eligible).length: 1;
    let activeCreditCount = product.creditArr ? product.creditArr.filter( x => x === true ).length : (product.credit === true ? 1 : 0);
    let creditsAvailibleForBook = Math.min(countCreditEligible+1, activeCreditCount + computedCart.credits_available +1);
    let oCreditColumn = '', oCreditColumnMobile = '';

    if(this.state.showCredit && countCreditEligible > 0 && credit_total && credit_total > 0 ){
      oCreditColumn =  (
        <td className="col-fourth2 for-desktop">
          <div className={"button credit-btn unselectable" + (activeCreditCount > 0 ? " active" : "")} >
            <div className="select-wrapper small">
              <select className="credits quantity"
                onChange={this.creditAlter.bind(this, product.id)} value={activeCreditCount}>
                { new Array(creditsAvailibleForBook).fill().map( (x, i) => (<option value={i}>{i}</option>)) }
              </select>
            </div>
            <span className="button-text">
              {activeCreditCount > 0 ? activeCreditCount + ' Credit Applied' : 'Click to Apply a Credit'}
            </span>
          </div>
        </td>
      );
      oCreditColumnMobile = (
        <td className="col-fourth2 for-mobile">
          <div className={"button credit-btn unselectable" + (activeCreditCount > 0 ? " active" : "")} >
            <div className="select-wrapper small">
              <select className="credits quantity"
                onChange={this.creditAlter.bind(this, product.id)} value={activeCreditCount}>
                { new Array(creditsAvailibleForBook).fill().map( (x, i) => (<option value={i}>{i}</option>)) }
              </select>
            </div>
            <span className="button-text">
              {activeCreditCount > 0 ? activeCreditCount + ' Credit Applied' : 'Click to Apply a Credit'}
            </span>
          </div>
        </td>
      );
    } else if(credit_total && credit_total > 0){
      oCreditColumn = (<td className="col-fourth2 for-desktop" />);
      oCreditColumnMobile = (<td className="col-fourth2 for-mobile" />);
    }

    const sImageSrc = '//s3.amazonaws.com/bookspan-media/covers/thumb/' + product.mmid + '.jpg';
    let lpMedallion = product.format === 'large_print' ? <img src={"/images/theme-default/lp-icon.svg"} /> : '';

    let ePromoCode = hasPromo && promo ? (<div className="promo-desc">{promo.blurb}</div>) : '';
    let specialPrice = product.subPrices ? product.subPrices.filter( x => x < product.sale_price && x > 0).length > 0 : false;

    let hasFullCreditApplied = (this.state.showCredit && activeCreditCount === product.quantity) ? true : false;
    let hasSomeCreditsApplied = ( activeCreditCount !== product.quantity && activeCreditCount > 0);

    let eNewPrice = '';
    if (!hasFullCreditApplied && hasPromo || specialPrice) eNewPrice = <div className="price-new">{'$' + parseFloat(product.computed_price).toFixed(2)}</div>;
    else if(hasSomeCreditsApplied) eNewPrice = <div>{'$' + parseFloat(product.computed_price).toFixed(2)}</div>;

    return (
      <tr className="cart-item">
        <td className="col-first">
          <div className="product-scaled-wrapper">
            <div
            className="remove inline"
            onClick={() => this.props.dispatch(removeCartProduct( product ))} >
              <svg version="1.1"x="0px" y="0px"
                   width="22.666px" height="22.667px" viewBox="0 0 22.666 22.667" enable-background="new 0 0 22.666 22.667" >
                <circle id="bgFill" fill="#FFFFFF" cx="11.436" cy="11.108" r="9.522"/>
                <path fill="#231F20" d="M11.379,22.325c-6.108,0-11.078-4.969-11.078-11.077S5.271,0.169,11.379,0.169s11.077,4.97,11.077,11.078
                  S17.487,22.325,11.379,22.325z M11.379,2.669c-4.73,0-8.578,3.848-8.578,8.578c0,4.729,3.848,8.577,8.578,8.577
                  c4.729,0,8.577-3.848,8.577-8.577C19.956,6.518,16.108,2.669,11.379,2.669z"/>
                <polygon fill="#231F20" points="17.634,6.758 15.866,4.991 11.462,9.396 7.057,4.991 5.29,6.758 9.694,11.164 5.29,15.57
                  7.057,17.337 11.462,12.932 15.866,17.337 17.634,15.57 13.229,11.164 "/>
              </svg>
            </div>
            <img src={sImageSrc} className="product-scaled" />
          </div>
        </td>
        <td className="col-second">
          <div className="title">
            <span>{product.title}</span>
            {ePromoCode}
          </div>
          <div className={"lp-medalion" + (this.state.showCredit || this.props.store_type === "Negative Option" ? "" : " less") }>{lpMedallion}</div>
        </td>
        <td className="col-third">
          <span>{product.sale_price}</span>
        </td>
        <td className="col-fourth">
          <div className="for-mobile">x</div>
          <div className="select-wrapper small">
            <select className="quantity" onChange={this.quantityAlter.bind(this, product)} value={product.quantity ? product.quantity.toString() : "1"}>
              { new Array(MAX_QUANTITY).fill().map( (x, i) => (<option value={i+1}>{i+1}</option>)) }
            </select>
          </div>
        </td>
        {oCreditColumn}
        <td className="col-fifth">
          <span className={ !hasFullCreditApplied && hasPromo || specialPrice ? 'price-old': ( hasSomeCreditsApplied ? 'price-credit' : '')}>
            { hasFullCreditApplied ?
              'Credit' + (activeCreditCount>1 ? 's' : '') :
              ( hasPromo || specialPrice || hasSomeCreditsApplied ?  '$' + parseFloat(product.sale_price * product.quantity).toFixed(2) : '$' + parseFloat(product.computed_price).toFixed(2) )
            }
          </span>
          {eNewPrice}
        </td>
        {oCreditColumnMobile}
      </tr>
    );
  }
};



function mapStateToProps(state){
    return {
      'credit_eligible': state.store.credit_eligible,
      'computedCart': state.computedCart,
      'store_bundle_pricing': state.store.bundle_pricing,
      'store_type': state.store.type,
      'credit_total': state.customer.credit_total
    };
}

export default connect(mapStateToProps)(ModalCartItem);


// WEBPACK FOOTER //
// ./src/components/ModalCartItem.jsx